module.exports = __webpack_public_path__ + "img/视频封面6.da96d749.png";